import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  // Initialize with a random time between 47 and 59 minutes (in seconds)
  const [timeLeft, setTimeLeft] = useState(() => {
    return Math.floor(Math.random() * (59 - 47 + 1) + 47) * 60 + Math.floor(Math.random() * 60);
  });
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          // Reset to random time between 47-59 min when it hits zero
          return Math.floor(Math.random() * (59 - 47 + 1) + 47) * 60;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <AnimatePresence data-id="element-309">
      {isVisible && <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -50,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 z-50 bg-[#111] text-white py-2 px-4 shadow-lg border-b border-yellow-500/30" data-id="element-310">
          <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs sm:text-sm" data-id="element-311">
            {/* Left Side: Urgency Message */}
            <div className="flex items-center gap-2" data-id="element-312">
              <span className="relative flex h-3 w-3" data-id="element-313">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-314"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600" data-id="element-315"></span>
              </span>
              <span className="font-bold uppercase tracking-wide text-gray-100" data-id="element-316">
                OFERTA LIMITADA:{' '}
                <span className="text-yellow-400" data-id="element-317">Solo quedan 7 copias</span>{' '}
                disponibles
              </span>
            </div>

            {/* Right Side: Countdown */}
            <div className="flex items-center gap-2 font-medium" data-id="element-318">
              <Clock className="w-4 h-4 text-yellow-500" data-id="element-319" />
              <span className="text-gray-300 hidden sm:inline" data-id="element-320">
                La oferta expira en:
              </span>
              <span className="font-mono text-yellow-400 text-base font-bold bg-white/10 px-2 py-0.5 rounded" data-id="element-321">
                {String(minutes).padStart(2, '0')}:
                {String(seconds).padStart(2, '0')}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}